import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import { PaymentLinksURL } from '../../../utils/paymentUrls';
import { track } from '../../../tracking/track';
import { events } from '../../../tracking/events';
import ModalWrapper from '../ModalWrapper';
import GoToPaymentsButtonWrapper from '../../GoToPaymentsButtonWrapper';
import { useScopes } from 'growth-payments-core/auth/scopes';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { PAYMENT_LINKS_WRITE } from '../../../constants/scopes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const GetPaidWithPaymentLinksModal = ({
  onClose,
  page,
  location,
  ButtonPrimary = GoToPaymentsButtonWrapper
}) => {
  const scopes = useScopes();
  const hasPaymentLinksWrite = scopes.has(PAYMENT_LINKS_WRITE);
  const Body = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.getPaidWithPaymentLinksModal.p1"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      styled: true,
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.getPaidWithPaymentLinksModal.bullet1"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.getPaidWithPaymentLinksModal.bullet2"
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.getPaidWithPaymentLinksModal.bullet3"
      })]
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "embedPoints.getPaidWithPaymentLinksModal.p2"
    })]
  });
  const Footer = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ButtonPrimary, {
      page: page,
      location: location,
      use: "primary"
    }), /*#__PURE__*/_jsx(UITooltip, {
      placement: "right",
      disabled: hasPaymentLinksWrite,
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "embedPoints.tooltips.missingPermissions"
      }),
      children: /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": "createTestPaymentLinkButton",
        use: "secondary",
        rel: "noopener" // override the rel attribute to remove the "noreferrer" tag, slack ref - https://hubspot.slack.com/archives/CEZNHE030/p1696003611704799
        ,
        disabled: !hasPaymentLinksWrite,
        external: true,
        href: PaymentLinksURL,
        onClick: () => track(events.paymentsInterstitialModalInteraction, {
          action: 'click',
          screen: page,
          value: 'createTestPaymentLink'
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "embedPoints.ctas.createPaymentLink"
        })
      })
    })]
  });
  return /*#__PURE__*/_jsx(ModalWrapper, {
    onClose: onClose,
    modalName: "getPaidWithPaymentLinksModal",
    Body: Body,
    Footer: Footer
  });
};
export default GetPaidWithPaymentLinksModal;